/**
 * API Gateway
 * API Gateway Единая точка входа для android, ios и web.  Модели ответов сервиса соответствуют спецификации, кроме случаев, когда возможны технические ответы (например, от ratelimiter или qrator). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';
import { API_OPTIONS_CONTEXT, ApiOptions }                   from '../api/api'

// @ts-ignore
import { BadRequestResponse } from '../model/badRequestResponse';
// @ts-ignore
import { BaseResponse } from '../model/baseResponse';
// @ts-ignore
import { ChangeRolePersonRequest } from '../model/changeRolePersonRequest';
// @ts-ignore
import { ConflictResponse } from '../model/conflictResponse';
// @ts-ignore
import { CreateDeliveryAddressRequest } from '../model/createDeliveryAddressRequest';
// @ts-ignore
import { CreateDeliveryAddressResponse } from '../model/createDeliveryAddressResponse';
// @ts-ignore
import { CreateLegalEntityRequest } from '../model/createLegalEntityRequest';
// @ts-ignore
import { CreatePersonRequest } from '../model/createPersonRequest';
// @ts-ignore
import { DeleteDeliveryAddressResponse } from '../model/deleteDeliveryAddressResponse';
// @ts-ignore
import { DeletePersonRequest } from '../model/deletePersonRequest';
// @ts-ignore
import { DictionaryLegalEntityList } from '../model/dictionaryLegalEntityList';
// @ts-ignore
import { EdiOperator } from '../model/ediOperator';
// @ts-ignore
import { EdoDoc } from '../model/edoDoc';
// @ts-ignore
import { EdoRequestsResponse } from '../model/edoRequestsResponse';
// @ts-ignore
import { GetDeliveryAddressResponse } from '../model/getDeliveryAddressResponse';
// @ts-ignore
import { GetLegalEntityDocumentsResponse } from '../model/getLegalEntityDocumentsResponse';
// @ts-ignore
import { GetLegalEntityGisResponse } from '../model/getLegalEntityGisResponse';
// @ts-ignore
import { GetLegalEntityListResponse } from '../model/getLegalEntityListResponse';
// @ts-ignore
import { GetManagerLegalEntityListResponse } from '../model/getManagerLegalEntityListResponse';
// @ts-ignore
import { LegalEntityAdditionalUpdateRequest } from '../model/legalEntityAdditionalUpdateRequest';
// @ts-ignore
import { LegalEntityBankRequest } from '../model/legalEntityBankRequest';
// @ts-ignore
import { LegalEntityData } from '../model/legalEntityData';
// @ts-ignore
import { LegalEntityDebtsResponse } from '../model/legalEntityDebtsResponse';
// @ts-ignore
import { LegalEntityEdoRecactResponse } from '../model/legalEntityEdoRecactResponse';
// @ts-ignore
import { LegalEntityEmailRequest } from '../model/legalEntityEmailRequest';
// @ts-ignore
import { LegalEntityFavoriteUpdate } from '../model/legalEntityFavoriteUpdate';
// @ts-ignore
import { LegalEntityInvoiceRequest } from '../model/legalEntityInvoiceRequest';
// @ts-ignore
import { LegalEntityInvoiceResponse } from '../model/legalEntityInvoiceResponse';
// @ts-ignore
import { LegalEntityInvoicesArchiveRequest } from '../model/legalEntityInvoicesArchiveRequest';
// @ts-ignore
import { LegalEntityOperationsHistory } from '../model/legalEntityOperationsHistory';
// @ts-ignore
import { LegalEntityOrderInvoiceResponse } from '../model/legalEntityOrderInvoiceResponse';
// @ts-ignore
import { LegalEntityOrderItemsCertsResponse } from '../model/legalEntityOrderItemsCertsResponse';
// @ts-ignore
import { NotFoundResponse } from '../model/notFoundResponse';
// @ts-ignore
import { OrgInfoResponse } from '../model/orgInfoResponse';
// @ts-ignore
import { PermissionDeniedResponse } from '../model/permissionDeniedResponse';
// @ts-ignore
import { PersonList } from '../model/personList';
// @ts-ignore
import { PostLegalEntityGisRequest } from '../model/postLegalEntityGisRequest';
// @ts-ignore
import { RecActRequest } from '../model/recActRequest';
// @ts-ignore
import { RedirectData } from '../model/redirectData';
// @ts-ignore
import { SearchAddressList } from '../model/searchAddressList';
// @ts-ignore
import { SearchBankResponse } from '../model/searchBankResponse';
// @ts-ignore
import { TooManyRequestsResponse } from '../model/tooManyRequestsResponse';
// @ts-ignore
import { UpdateContractRequest } from '../model/updateContractRequest';
// @ts-ignore
import { UpdateDeliveryAddressRequest } from '../model/updateDeliveryAddressRequest';
// @ts-ignore
import { UpdateDeliveryAddressResponse } from '../model/updateDeliveryAddressResponse';
// @ts-ignore
import { UpdateEdoRequest } from '../model/updateEdoRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface ChangeRolePersonRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    changeRolePersonRequest?: ChangeRolePersonRequest;
}

export interface ConfirmLegalEntityEmailRequestParams {
    guid: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface CreateB2bDeliveryAddressRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** По данному заголовку определяются установленные эксперименты */
    experiments?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    createDeliveryAddressRequest?: CreateDeliveryAddressRequest;
}

export interface CreateB2bLegalEntityOrderItemsCertsPdfRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Номер заказа */
    orderId: string;
    /** Дата заказа */
    orderDate: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface CreateLegalEntityRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    referer?: string;
    cookie?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    createLegalEntityRequest?: CreateLegalEntityRequest;
}

export interface CreateLegalEntityPersonRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    createPersonRequest?: CreatePersonRequest;
}

export interface DeleteB2bDeliveryAddressRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    addressId?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface DeletePersonRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    deletePersonRequest?: DeletePersonRequest;
}

export interface GetB2bDeliveryAddressRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    addressId?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetB2bLegalEntityRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    deviceID?: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetB2bLegalEntityDebtsRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetB2bLegalEntityDocumentsRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetB2bLegalEntityListRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetB2bLegalEntityOrderInvoiceRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Номер заказа. Устарел, используйте одноимённый query-параметр. Оставлен временно для обратной совместимости.  */
    orderId?: string;
    /** Номер заказа */
    orderId2?: string;
    /** Сумма счета в копейках, для фильтрации в случае нескольких счетов по одному заказу */
    sum?: number;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetB2bLegalEntityOrderItemsCertsRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Номер заказа */
    orderId: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetB2bManagerLegalEntityListRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetB2bSearchAddressesRequestParams {
    symbol: string;
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    limit?: number;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetB2bSearchBankRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    bic: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetEdiOperatorsRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Только активные записи */
    active?: boolean;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetLegalEntityEdoRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetLegalEntityEdoDocsRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetLegalEntityEdoRecactRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetLegalEntityGisRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetLegalEntityOperationsHistoryRequestParams {
    /** Начало интервала */
    startDate: number;
    /** Конец интервала */
    endDate: number;
    /** Тип операции */
    operationType: 'add' | 'withdrawal' | 'all';
    /** Количество операций на странице */
    limit: number;
    /** Сдвиг */
    offset: number;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetLegalEntityOrgInfoRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetLegalEntityPersonRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface GetSearchLegalEntityByInnRequestParams {
    query: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface LegalEntityInvoiceRequestParams {
    /** Тип формируемого счета */
    invoiceType: 'payment' | 'payment_pos' | 'prepayment';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    legalEntityInvoiceRequest: LegalEntityInvoiceRequest;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface LegalEntityInvoicesArchiveRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    legalEntityInvoicesArchiveRequest: LegalEntityInvoicesArchiveRequest;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface LegalEntityRecActRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    recActRequest?: RecActRequest;
}

export interface PostLegalEntityAlcoOwnNeedsRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    body: object;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface PostLegalEntityGisRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    postLegalEntityGisRequest?: PostLegalEntityGisRequest;
}

export interface UpdateB2bDeliveryAddressRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    updateDeliveryAddressRequest?: UpdateDeliveryAddressRequest;
}

export interface UpdateContractRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    updateContractRequest?: UpdateContractRequest;
}

export interface UpdateContractAdditionalRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    legalEntityAdditionalUpdateRequest?: LegalEntityAdditionalUpdateRequest;
}

export interface UpdateFavoriteLegalEntityRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    legalEntityFavoriteUpdate?: LegalEntityFavoriteUpdate;
}

export interface UpdateLegalEntityBankDataRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    legalEntityBankRequest?: LegalEntityBankRequest;
}

export interface UpdateLegalEntityEdoRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    updateEdoRequest?: UpdateEdoRequest;
}

export interface UpdateLegalEntityEdoRecactRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface UpdateLegalEntityEmailRequestParams {
    /** Сессионный токен (гостевой) */
    sessionToken: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** Время запроса (используется для обхода кэша на Web) */
    timestamp?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
    legalEntityEmailRequest?: LegalEntityEmailRequest;
}


@Injectable({
  providedIn: 'root'
})
export class B2BService {

    protected basePath = 'https://api.lenta.com/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Сделать представителя основным
     * Назначает представителя основным в организации. Инициатор должен иметь роль admin в организации.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeRolePerson(requestParameters: ChangeRolePersonRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public changeRolePerson(requestParameters: ChangeRolePersonRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public changeRolePerson(requestParameters: ChangeRolePersonRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public changeRolePerson(requestParameters: ChangeRolePersonRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling changeRolePerson.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling changeRolePerson.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling changeRolePerson.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const changeRolePersonRequest = requestParameters.changeRolePersonRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/person/changeRole`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: changeRolePersonRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Подтвердить email
     * Подтверждает, что email принадлежит организации
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public confirmLegalEntityEmail(requestParameters: ConfirmLegalEntityEmailRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RedirectData>;
    public confirmLegalEntityEmail(requestParameters: ConfirmLegalEntityEmailRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RedirectData>>;
    public confirmLegalEntityEmail(requestParameters: ConfirmLegalEntityEmailRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RedirectData>>;
    public confirmLegalEntityEmail(requestParameters: ConfirmLegalEntityEmailRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const guid = requestParameters.guid;
        if (guid === null || guid === undefined) {
            throw new Error('Required parameter guid was null or undefined when calling confirmLegalEntityEmail.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling confirmLegalEntityEmail.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling confirmLegalEntityEmail.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (guid !== undefined && guid !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>guid, 'guid');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/email/confirm`;
        return this.httpClient.request<RedirectData>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Добавить адрес доставки
     * Добавляет адрес доставки для организации. Вернет ID добавленного адреса и список всех адресов
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createB2bDeliveryAddress(requestParameters: CreateB2bDeliveryAddressRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<CreateDeliveryAddressResponse>;
    public createB2bDeliveryAddress(requestParameters: CreateB2bDeliveryAddressRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<CreateDeliveryAddressResponse>>;
    public createB2bDeliveryAddress(requestParameters: CreateB2bDeliveryAddressRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<CreateDeliveryAddressResponse>>;
    public createB2bDeliveryAddress(requestParameters: CreateB2bDeliveryAddressRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling createB2bDeliveryAddress.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling createB2bDeliveryAddress.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const experiments = requestParameters.experiments;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const createDeliveryAddressRequest = requestParameters.createDeliveryAddressRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (experiments !== undefined && experiments !== null) {
            localVarHeaders = localVarHeaders.set('Experiments', String(experiments));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/address/create`;
        return this.httpClient.request<CreateDeliveryAddressResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createDeliveryAddressRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Создать PDF-файл со ссылками на сертификаты по заказу
     * Отправка запроса для получения PDF-файла со ссылками на сертификаты по заказу. Ответ отдаётся бинарным телом application/pdf для скачивания. 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createB2bLegalEntityOrderItemsCertsPdf(requestParameters: CreateB2bLegalEntityOrderItemsCertsPdfRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext}): Observable<Blob>;
    public createB2bLegalEntityOrderItemsCertsPdf(requestParameters: CreateB2bLegalEntityOrderItemsCertsPdfRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext}): Observable<HttpResponse<Blob>>;
    public createB2bLegalEntityOrderItemsCertsPdf(requestParameters: CreateB2bLegalEntityOrderItemsCertsPdfRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext}): Observable<HttpEvent<Blob>>;
    public createB2bLegalEntityOrderItemsCertsPdf(requestParameters: CreateB2bLegalEntityOrderItemsCertsPdfRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling createB2bLegalEntityOrderItemsCertsPdf.');
        }
        const orderId = requestParameters.orderId;
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling createB2bLegalEntityOrderItemsCertsPdf.');
        }
        const orderDate = requestParameters.orderDate;
        if (orderDate === null || orderDate === undefined) {
            throw new Error('Required parameter orderDate was null or undefined when calling createB2bLegalEntityOrderItemsCertsPdf.');
        }
        const xOrganizationID = requestParameters.xOrganizationID;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (orderId !== undefined && orderId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderId, 'orderId');
        }
        if (orderDate !== undefined && orderDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderDate, 'orderDate');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/pdf',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let localVarPath = `/b2b/legalEntity/order/certs/pdf`;
        return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Создание ЮЛ
     * Создает организацию по ИНН. При повторной отправки вернет идемпотентный ответ по ИНН и owner.passportId; Если owner.passportId будет иным - вернет 403
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createLegalEntity(requestParameters: CreateLegalEntityRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<LegalEntityData>;
    public createLegalEntity(requestParameters: CreateLegalEntityRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<LegalEntityData>>;
    public createLegalEntity(requestParameters: CreateLegalEntityRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<LegalEntityData>>;
    public createLegalEntity(requestParameters: CreateLegalEntityRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling createLegalEntity.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling createLegalEntity.');
        }
        const referer = requestParameters.referer;
        const cookie = requestParameters.cookie;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const createLegalEntityRequest = requestParameters.createLegalEntityRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (referer !== undefined && referer !== null) {
            localVarHeaders = localVarHeaders.set('Referer', String(referer));
        }
        if (cookie !== undefined && cookie !== null) {
            localVarHeaders = localVarHeaders.set('Cookie', String(cookie));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/create`;
        return this.httpClient.request<LegalEntityData>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createLegalEntityRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Добавить пользователя
     * Добавляет пользователя и связывает его с организацией. Если пользователь уже был, обновляет его данные и связывает с юр.лицом
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createLegalEntityPerson(requestParameters: CreateLegalEntityPersonRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PersonList>;
    public createLegalEntityPerson(requestParameters: CreateLegalEntityPersonRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PersonList>>;
    public createLegalEntityPerson(requestParameters: CreateLegalEntityPersonRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PersonList>>;
    public createLegalEntityPerson(requestParameters: CreateLegalEntityPersonRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling createLegalEntityPerson.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling createLegalEntityPerson.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling createLegalEntityPerson.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const createPersonRequest = requestParameters.createPersonRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/person/create`;
        return this.httpClient.request<PersonList>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createPersonRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Удалить адрес доставки
     * Удаляет адрес доставки. Вернет список всех адресов
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteB2bDeliveryAddress(requestParameters: DeleteB2bDeliveryAddressRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<DeleteDeliveryAddressResponse>;
    public deleteB2bDeliveryAddress(requestParameters: DeleteB2bDeliveryAddressRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<DeleteDeliveryAddressResponse>>;
    public deleteB2bDeliveryAddress(requestParameters: DeleteB2bDeliveryAddressRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<DeleteDeliveryAddressResponse>>;
    public deleteB2bDeliveryAddress(requestParameters: DeleteB2bDeliveryAddressRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling deleteB2bDeliveryAddress.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling deleteB2bDeliveryAddress.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const addressId = requestParameters.addressId;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }
        if (addressId !== undefined && addressId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>addressId, 'addressId');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/address/delete`;
        return this.httpClient.request<DeleteDeliveryAddressResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Удалить представителя из организации
     * Деактивирует представителя в организации. Инициатор должен иметь роль admin в организации.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletePerson(requestParameters: DeletePersonRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public deletePerson(requestParameters: DeletePersonRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public deletePerson(requestParameters: DeletePersonRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public deletePerson(requestParameters: DeletePersonRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling deletePerson.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling deletePerson.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling deletePerson.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const deletePersonRequest = requestParameters.deletePersonRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/person/delete`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: deletePersonRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить адреса доставки или конкретный адрес
     * Возвращает список адресов организации. Если адресов нет - вернет пустой массив. Если в запросе указан ID адреса - вернет один элемент в массиве или пустой массив. 404 возвращается в случае, если указанного ИНН не существует
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getB2bDeliveryAddress(requestParameters: GetB2bDeliveryAddressRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GetDeliveryAddressResponse>;
    public getB2bDeliveryAddress(requestParameters: GetB2bDeliveryAddressRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GetDeliveryAddressResponse>>;
    public getB2bDeliveryAddress(requestParameters: GetB2bDeliveryAddressRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GetDeliveryAddressResponse>>;
    public getB2bDeliveryAddress(requestParameters: GetB2bDeliveryAddressRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getB2bDeliveryAddress.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getB2bDeliveryAddress.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const addressId = requestParameters.addressId;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }
        if (addressId !== undefined && addressId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>addressId, 'addressId');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/address`;
        return this.httpClient.request<GetDeliveryAddressResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Полная информация по ЮЛ
     * Запрос информации о юридическом лице по UUID. 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getB2bLegalEntity(requestParameters: GetB2bLegalEntityRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<LegalEntityData>;
    public getB2bLegalEntity(requestParameters: GetB2bLegalEntityRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<LegalEntityData>>;
    public getB2bLegalEntity(requestParameters: GetB2bLegalEntityRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<LegalEntityData>>;
    public getB2bLegalEntity(requestParameters: GetB2bLegalEntityRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getB2bLegalEntity.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling getB2bLegalEntity.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getB2bLegalEntity.');
        }
        const deviceID = requestParameters.deviceID;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (deviceID !== undefined && deviceID !== null) {
            localVarHeaders = localVarHeaders.set('DeviceID', String(deviceID));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity`;
        return this.httpClient.request<LegalEntityData>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить список задолженностей
     * Получение списка задолженностей клиента с Кредитным лимитом 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getB2bLegalEntityDebts(requestParameters: GetB2bLegalEntityDebtsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<LegalEntityDebtsResponse>;
    public getB2bLegalEntityDebts(requestParameters: GetB2bLegalEntityDebtsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<LegalEntityDebtsResponse>>;
    public getB2bLegalEntityDebts(requestParameters: GetB2bLegalEntityDebtsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<LegalEntityDebtsResponse>>;
    public getB2bLegalEntityDebts(requestParameters: GetB2bLegalEntityDebtsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getB2bLegalEntityDebts.');
        }
        const xOrganizationID = requestParameters.xOrganizationID;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/debts`;
        return this.httpClient.request<LegalEntityDebtsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Список активных документов
     * Возвращает список активных документов по коллекциям
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getB2bLegalEntityDocuments(requestParameters: GetB2bLegalEntityDocumentsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GetLegalEntityDocumentsResponse>;
    public getB2bLegalEntityDocuments(requestParameters: GetB2bLegalEntityDocumentsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GetLegalEntityDocumentsResponse>>;
    public getB2bLegalEntityDocuments(requestParameters: GetB2bLegalEntityDocumentsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GetLegalEntityDocumentsResponse>>;
    public getB2bLegalEntityDocuments(requestParameters: GetB2bLegalEntityDocumentsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getB2bLegalEntityDocuments.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getB2bLegalEntityDocuments.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/documents`;
        return this.httpClient.request<GetLegalEntityDocumentsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Список привязанных ЮЛ к аккаунту клиента
     * Возвращает список связанных с пользователем юридических лиц. Вернет пустой массив, если связей нет
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getB2bLegalEntityList(requestParameters: GetB2bLegalEntityListRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GetLegalEntityListResponse>;
    public getB2bLegalEntityList(requestParameters: GetB2bLegalEntityListRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GetLegalEntityListResponse>>;
    public getB2bLegalEntityList(requestParameters: GetB2bLegalEntityListRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GetLegalEntityListResponse>>;
    public getB2bLegalEntityList(requestParameters: GetB2bLegalEntityListRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getB2bLegalEntityList.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getB2bLegalEntityList.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/person`;
        return this.httpClient.request<GetLegalEntityListResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить счет на оплату по заказу
     * Успешный ответ. Возвращает либо данные последнего счета (если они существуют), либо пустой объект, если счетов не сформировано по данному orderId. 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getB2bLegalEntityOrderInvoice(requestParameters: GetB2bLegalEntityOrderInvoiceRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<LegalEntityOrderInvoiceResponse>;
    public getB2bLegalEntityOrderInvoice(requestParameters: GetB2bLegalEntityOrderInvoiceRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<LegalEntityOrderInvoiceResponse>>;
    public getB2bLegalEntityOrderInvoice(requestParameters: GetB2bLegalEntityOrderInvoiceRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<LegalEntityOrderInvoiceResponse>>;
    public getB2bLegalEntityOrderInvoice(requestParameters: GetB2bLegalEntityOrderInvoiceRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getB2bLegalEntityOrderInvoice.');
        }
        const xOrganizationID = requestParameters.xOrganizationID;
        const orderId = requestParameters.orderId;
        const orderId2 = requestParameters.orderId2;
        const sum = requestParameters.sum;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (orderId2 !== undefined && orderId2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderId2, 'orderId');
        }
        if (sum !== undefined && sum !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sum, 'sum');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (orderId !== undefined && orderId !== null) {
            localVarHeaders = localVarHeaders.set('orderId', String(orderId));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/order/invoice`;
        return this.httpClient.request<LegalEntityOrderInvoiceResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить ссылки на сертификаты по заказу
     * Возвращает сохранённые ссылки на сертификаты/декларации по заказу 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getB2bLegalEntityOrderItemsCerts(requestParameters: GetB2bLegalEntityOrderItemsCertsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<LegalEntityOrderItemsCertsResponse>;
    public getB2bLegalEntityOrderItemsCerts(requestParameters: GetB2bLegalEntityOrderItemsCertsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<LegalEntityOrderItemsCertsResponse>>;
    public getB2bLegalEntityOrderItemsCerts(requestParameters: GetB2bLegalEntityOrderItemsCertsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<LegalEntityOrderItemsCertsResponse>>;
    public getB2bLegalEntityOrderItemsCerts(requestParameters: GetB2bLegalEntityOrderItemsCertsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getB2bLegalEntityOrderItemsCerts.');
        }
        const orderId = requestParameters.orderId;
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling getB2bLegalEntityOrderItemsCerts.');
        }
        const xOrganizationID = requestParameters.xOrganizationID;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (orderId !== undefined && orderId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderId, 'orderId');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/order/certs`;
        return this.httpClient.request<LegalEntityOrderItemsCertsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Список привязанных ЮЛ к аккаунту менеджера
     * Возвращает список связанных с менеджером юридических лиц. Вернет пустой массив, если связей нет
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getB2bManagerLegalEntityList(requestParameters: GetB2bManagerLegalEntityListRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GetManagerLegalEntityListResponse>;
    public getB2bManagerLegalEntityList(requestParameters: GetB2bManagerLegalEntityListRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GetManagerLegalEntityListResponse>>;
    public getB2bManagerLegalEntityList(requestParameters: GetB2bManagerLegalEntityListRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GetManagerLegalEntityListResponse>>;
    public getB2bManagerLegalEntityList(requestParameters: GetB2bManagerLegalEntityListRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getB2bManagerLegalEntityList.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getB2bManagerLegalEntityList.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/manager`;
        return this.httpClient.request<GetManagerLegalEntityListResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Поиск адресов
     * Поиск адресов по сочетанию входящих символов
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getB2bSearchAddresses(requestParameters: GetB2bSearchAddressesRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<SearchAddressList>;
    public getB2bSearchAddresses(requestParameters: GetB2bSearchAddressesRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<SearchAddressList>>;
    public getB2bSearchAddresses(requestParameters: GetB2bSearchAddressesRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<SearchAddressList>>;
    public getB2bSearchAddresses(requestParameters: GetB2bSearchAddressesRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const symbol = requestParameters.symbol;
        if (symbol === null || symbol === undefined) {
            throw new Error('Required parameter symbol was null or undefined when calling getB2bSearchAddresses.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getB2bSearchAddresses.');
        }
        const limit = requestParameters.limit;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (symbol !== undefined && symbol !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>symbol, 'symbol');
        }
        if (limit !== undefined && limit !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>limit, 'limit');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/address/suggest`;
        return this.httpClient.request<SearchAddressList>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Поиск в словаре банка по БИК
     * Ищет банки в словаре по БИК или его начальной части. Если ничего не найдено - вернет пустой массив
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getB2bSearchBank(requestParameters: GetB2bSearchBankRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<SearchBankResponse>;
    public getB2bSearchBank(requestParameters: GetB2bSearchBankRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<SearchBankResponse>>;
    public getB2bSearchBank(requestParameters: GetB2bSearchBankRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<SearchBankResponse>>;
    public getB2bSearchBank(requestParameters: GetB2bSearchBankRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getB2bSearchBank.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getB2bSearchBank.');
        }
        const bic = requestParameters.bic;
        if (bic === null || bic === undefined) {
            throw new Error('Required parameter bic was null or undefined when calling getB2bSearchBank.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }
        if (bic !== undefined && bic !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>bic, 'bic');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/bank/search`;
        return this.httpClient.request<SearchBankResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить список ЭДО операторов
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEdiOperators(requestParameters: GetEdiOperatorsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<EdiOperator>>;
    public getEdiOperators(requestParameters: GetEdiOperatorsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<EdiOperator>>>;
    public getEdiOperators(requestParameters: GetEdiOperatorsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<EdiOperator>>>;
    public getEdiOperators(requestParameters: GetEdiOperatorsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getEdiOperators.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling getEdiOperators.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getEdiOperators.');
        }
        const active = requestParameters.active;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (active !== undefined && active !== null) {
            localVarHeaders = localVarHeaders.set('active', String(active));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/ediOperators`;
        return this.httpClient.request<Array<EdiOperator>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить информацию о подключении к ЭДО
     * Получить информацию о подключении к ЭДО
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLegalEntityEdo(requestParameters: GetLegalEntityEdoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<EdoRequestsResponse>;
    public getLegalEntityEdo(requestParameters: GetLegalEntityEdoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<EdoRequestsResponse>>;
    public getLegalEntityEdo(requestParameters: GetLegalEntityEdoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<EdoRequestsResponse>>;
    public getLegalEntityEdo(requestParameters: GetLegalEntityEdoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getLegalEntityEdo.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/edo`;
        return this.httpClient.request<EdoRequestsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить информацию о подключенных документах ЭДО
     * Получить информацию о подключенных документах ЭДО
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLegalEntityEdoDocs(requestParameters: GetLegalEntityEdoDocsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<EdoDoc>>;
    public getLegalEntityEdoDocs(requestParameters: GetLegalEntityEdoDocsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<EdoDoc>>>;
    public getLegalEntityEdoDocs(requestParameters: GetLegalEntityEdoDocsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<EdoDoc>>>;
    public getLegalEntityEdoDocs(requestParameters: GetLegalEntityEdoDocsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getLegalEntityEdoDocs.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/edoDocs`;
        return this.httpClient.request<Array<EdoDoc>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить информацию о заявке на акты сверки ЭДО
     * Получить информацию о заявке на акты сверки ЭДО
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLegalEntityEdoRecact(requestParameters: GetLegalEntityEdoRecactRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<LegalEntityEdoRecactResponse>;
    public getLegalEntityEdoRecact(requestParameters: GetLegalEntityEdoRecactRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<LegalEntityEdoRecactResponse>>;
    public getLegalEntityEdoRecact(requestParameters: GetLegalEntityEdoRecactRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<LegalEntityEdoRecactResponse>>;
    public getLegalEntityEdoRecact(requestParameters: GetLegalEntityEdoRecactRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getLegalEntityEdoRecact.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/edo/recact`;
        return this.httpClient.request<LegalEntityEdoRecactResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получение заявок на получение адресов из ГИС систем
     * Получение заявок на получение адресов из ГИС систем
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLegalEntityGis(requestParameters: GetLegalEntityGisRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GetLegalEntityGisResponse>;
    public getLegalEntityGis(requestParameters: GetLegalEntityGisRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GetLegalEntityGisResponse>>;
    public getLegalEntityGis(requestParameters: GetLegalEntityGisRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GetLegalEntityGisResponse>>;
    public getLegalEntityGis(requestParameters: GetLegalEntityGisRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getLegalEntityGis.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling getLegalEntityGis.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getLegalEntityGis.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/gis`;
        return this.httpClient.request<GetLegalEntityGisResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить историю операций с балансом
     * Получить историю операций с балансом для ЮЛ за определенный период
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLegalEntityOperationsHistory(requestParameters: GetLegalEntityOperationsHistoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<LegalEntityOperationsHistory>;
    public getLegalEntityOperationsHistory(requestParameters: GetLegalEntityOperationsHistoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<LegalEntityOperationsHistory>>;
    public getLegalEntityOperationsHistory(requestParameters: GetLegalEntityOperationsHistoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<LegalEntityOperationsHistory>>;
    public getLegalEntityOperationsHistory(requestParameters: GetLegalEntityOperationsHistoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const startDate = requestParameters.startDate;
        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling getLegalEntityOperationsHistory.');
        }
        const endDate = requestParameters.endDate;
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling getLegalEntityOperationsHistory.');
        }
        const operationType = requestParameters.operationType;
        if (operationType === null || operationType === undefined) {
            throw new Error('Required parameter operationType was null or undefined when calling getLegalEntityOperationsHistory.');
        }
        const limit = requestParameters.limit;
        if (limit === null || limit === undefined) {
            throw new Error('Required parameter limit was null or undefined when calling getLegalEntityOperationsHistory.');
        }
        const offset = requestParameters.offset;
        if (offset === null || offset === undefined) {
            throw new Error('Required parameter offset was null or undefined when calling getLegalEntityOperationsHistory.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getLegalEntityOperationsHistory.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling getLegalEntityOperationsHistory.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getLegalEntityOperationsHistory.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (startDate !== undefined && startDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>startDate, 'startDate');
        }
        if (endDate !== undefined && endDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>endDate, 'endDate');
        }
        if (operationType !== undefined && operationType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>operationType, 'operationType');
        }
        if (limit !== undefined && limit !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>limit, 'limit');
        }
        if (offset !== undefined && offset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offset, 'offset');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/ophistory`;
        return this.httpClient.request<LegalEntityOperationsHistory>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить информацию об организации от провайдера
     * Получить информацию об организации от провайдера
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLegalEntityOrgInfo(requestParameters: GetLegalEntityOrgInfoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<OrgInfoResponse>;
    public getLegalEntityOrgInfo(requestParameters: GetLegalEntityOrgInfoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<OrgInfoResponse>>;
    public getLegalEntityOrgInfo(requestParameters: GetLegalEntityOrgInfoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<OrgInfoResponse>>;
    public getLegalEntityOrgInfo(requestParameters: GetLegalEntityOrgInfoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getLegalEntityOrgInfo.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling getLegalEntityOrgInfo.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getLegalEntityOrgInfo.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/orgInfo`;
        return this.httpClient.request<OrgInfoResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить список пользователей
     * Возвращает список всех активных пользователей, связанных с организацией, кроме персонального менеджера
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLegalEntityPerson(requestParameters: GetLegalEntityPersonRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PersonList>;
    public getLegalEntityPerson(requestParameters: GetLegalEntityPersonRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PersonList>>;
    public getLegalEntityPerson(requestParameters: GetLegalEntityPersonRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PersonList>>;
    public getLegalEntityPerson(requestParameters: GetLegalEntityPersonRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getLegalEntityPerson.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling getLegalEntityPerson.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getLegalEntityPerson.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/person`;
        return this.httpClient.request<PersonList>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Поиск юр.лица в словаре по ИНН
     * Ищет организации в словаре юр.лиц по ИНН, названию или части строки. Если ничего не найдено - вернет пустой массив
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSearchLegalEntityByInn(requestParameters: GetSearchLegalEntityByInnRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<DictionaryLegalEntityList>;
    public getSearchLegalEntityByInn(requestParameters: GetSearchLegalEntityByInnRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<DictionaryLegalEntityList>>;
    public getSearchLegalEntityByInn(requestParameters: GetSearchLegalEntityByInnRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<DictionaryLegalEntityList>>;
    public getSearchLegalEntityByInn(requestParameters: GetSearchLegalEntityByInnRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const query = requestParameters.query;
        if (query === null || query === undefined) {
            throw new Error('Required parameter query was null or undefined when calling getSearchLegalEntityByInn.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling getSearchLegalEntityByInn.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling getSearchLegalEntityByInn.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (query !== undefined && query !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>query, 'query');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/search`;
        return this.httpClient.request<DictionaryLegalEntityList>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить счет для юридического лица
     * Получение счета юридического лица по выбранному типу. 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public legalEntityInvoice(requestParameters: LegalEntityInvoiceRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<LegalEntityInvoiceResponse>;
    public legalEntityInvoice(requestParameters: LegalEntityInvoiceRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<LegalEntityInvoiceResponse>>;
    public legalEntityInvoice(requestParameters: LegalEntityInvoiceRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<LegalEntityInvoiceResponse>>;
    public legalEntityInvoice(requestParameters: LegalEntityInvoiceRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const invoiceType = requestParameters.invoiceType;
        if (invoiceType === null || invoiceType === undefined) {
            throw new Error('Required parameter invoiceType was null or undefined when calling legalEntityInvoice.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling legalEntityInvoice.');
        }
        const legalEntityInvoiceRequest = requestParameters.legalEntityInvoiceRequest;
        if (legalEntityInvoiceRequest === null || legalEntityInvoiceRequest === undefined) {
            throw new Error('Required parameter legalEntityInvoiceRequest was null or undefined when calling legalEntityInvoice.');
        }
        const xOrganizationID = requestParameters.xOrganizationID;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/invoice/${this.configuration.encodeParam({name: "invoiceType", value: invoiceType, in: "path", style: "simple", explode: false, dataType: "'payment' | 'payment_pos' | 'prepayment'", dataFormat: undefined})}`;
        return this.httpClient.request<LegalEntityInvoiceResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: legalEntityInvoiceRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Получить архив со счетами для юридического лица
     * Формирование ZIP-архива счетов по задолженностей юридического лица. 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public legalEntityInvoicesArchive(requestParameters: LegalEntityInvoicesArchiveRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip' | 'application/json', context?: HttpContext}): Observable<Blob>;
    public legalEntityInvoicesArchive(requestParameters: LegalEntityInvoicesArchiveRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip' | 'application/json', context?: HttpContext}): Observable<HttpResponse<Blob>>;
    public legalEntityInvoicesArchive(requestParameters: LegalEntityInvoicesArchiveRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip' | 'application/json', context?: HttpContext}): Observable<HttpEvent<Blob>>;
    public legalEntityInvoicesArchive(requestParameters: LegalEntityInvoicesArchiveRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/zip' | 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling legalEntityInvoicesArchive.');
        }
        const legalEntityInvoicesArchiveRequest = requestParameters.legalEntityInvoicesArchiveRequest;
        if (legalEntityInvoicesArchiveRequest === null || legalEntityInvoicesArchiveRequest === undefined) {
            throw new Error('Required parameter legalEntityInvoicesArchiveRequest was null or undefined when calling legalEntityInvoicesArchive.');
        }
        const xOrganizationID = requestParameters.xOrganizationID;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/zip',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let localVarPath = `/b2b/legalEntity/invoice/archive`;
        return this.httpClient.request('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: legalEntityInvoicesArchiveRequest,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Заказ акта сверки
     * Заказ авта сверки для ЮЛ
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public legalEntityRecAct(requestParameters: LegalEntityRecActRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RecActRequest>;
    public legalEntityRecAct(requestParameters: LegalEntityRecActRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RecActRequest>>;
    public legalEntityRecAct(requestParameters: LegalEntityRecActRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RecActRequest>>;
    public legalEntityRecAct(requestParameters: LegalEntityRecActRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling legalEntityRecAct.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling legalEntityRecAct.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling legalEntityRecAct.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const recActRequest = requestParameters.recActRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/recact`;
        return this.httpClient.request<RecActRequest>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: recActRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Подключить покупку алко в собственные нужды
     * Подписание договора поставки алкоголя в собственные нужды онлайн
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postLegalEntityAlcoOwnNeeds(requestParameters: PostLegalEntityAlcoOwnNeedsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public postLegalEntityAlcoOwnNeeds(requestParameters: PostLegalEntityAlcoOwnNeedsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public postLegalEntityAlcoOwnNeeds(requestParameters: PostLegalEntityAlcoOwnNeedsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public postLegalEntityAlcoOwnNeeds(requestParameters: PostLegalEntityAlcoOwnNeedsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling postLegalEntityAlcoOwnNeeds.');
        }
        const body = requestParameters.body;
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling postLegalEntityAlcoOwnNeeds.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/alcoOwnNeeds`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Отправка запроса на получение адресов из ГИС систем
     * Отправка запроса на получение адресов из ГИС систем
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postLegalEntityGis(requestParameters: PostLegalEntityGisRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public postLegalEntityGis(requestParameters: PostLegalEntityGisRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public postLegalEntityGis(requestParameters: PostLegalEntityGisRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public postLegalEntityGis(requestParameters: PostLegalEntityGisRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling postLegalEntityGis.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling postLegalEntityGis.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling postLegalEntityGis.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const postLegalEntityGisRequest = requestParameters.postLegalEntityGisRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/gis`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: postLegalEntityGisRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Редактировать адрес доставки
     * Изменяет данные адреса доставки. Вернет список всех адресов
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateB2bDeliveryAddress(requestParameters: UpdateB2bDeliveryAddressRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<UpdateDeliveryAddressResponse>;
    public updateB2bDeliveryAddress(requestParameters: UpdateB2bDeliveryAddressRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<UpdateDeliveryAddressResponse>>;
    public updateB2bDeliveryAddress(requestParameters: UpdateB2bDeliveryAddressRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<UpdateDeliveryAddressResponse>>;
    public updateB2bDeliveryAddress(requestParameters: UpdateB2bDeliveryAddressRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling updateB2bDeliveryAddress.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling updateB2bDeliveryAddress.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const updateDeliveryAddressRequest = requestParameters.updateDeliveryAddressRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/address/update`;
        return this.httpClient.request<UpdateDeliveryAddressResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateDeliveryAddressRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Переподписание контракта
     * Переподписание контракта
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateContract(requestParameters: UpdateContractRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public updateContract(requestParameters: UpdateContractRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public updateContract(requestParameters: UpdateContractRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public updateContract(requestParameters: UpdateContractRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling updateContract.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling updateContract.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling updateContract.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const updateContractRequest = requestParameters.updateContractRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/contract/update`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateContractRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Передача подписания доп соглашения
     * Передает флаг подписания доп соглашения
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateContractAdditional(requestParameters: UpdateContractAdditionalRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public updateContractAdditional(requestParameters: UpdateContractAdditionalRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public updateContractAdditional(requestParameters: UpdateContractAdditionalRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public updateContractAdditional(requestParameters: UpdateContractAdditionalRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling updateContractAdditional.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling updateContractAdditional.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling updateContractAdditional.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const legalEntityAdditionalUpdateRequest = requestParameters.legalEntityAdditionalUpdateRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/contract/additional/update`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: legalEntityAdditionalUpdateRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Выставление флага избранной компании
     * Обновление флага избранной компании
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFavoriteLegalEntity(requestParameters: UpdateFavoriteLegalEntityRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public updateFavoriteLegalEntity(requestParameters: UpdateFavoriteLegalEntityRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public updateFavoriteLegalEntity(requestParameters: UpdateFavoriteLegalEntityRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public updateFavoriteLegalEntity(requestParameters: UpdateFavoriteLegalEntityRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling updateFavoriteLegalEntity.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling updateFavoriteLegalEntity.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling updateFavoriteLegalEntity.');
        }
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const legalEntityFavoriteUpdate = requestParameters.legalEntityFavoriteUpdate;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/favorite/update`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: legalEntityFavoriteUpdate,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Обновление банковских реквизитов
     * Устанавливает БИК и расчетный счет для организации
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLegalEntityBankData(requestParameters: UpdateLegalEntityBankDataRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public updateLegalEntityBankData(requestParameters: UpdateLegalEntityBankDataRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public updateLegalEntityBankData(requestParameters: UpdateLegalEntityBankDataRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public updateLegalEntityBankData(requestParameters: UpdateLegalEntityBankDataRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling updateLegalEntityBankData.');
        }
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling updateLegalEntityBankData.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const legalEntityBankRequest = requestParameters.legalEntityBankRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/bank/update`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: legalEntityBankRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Подключить ЭДО
     * Отправка заявки на подключние ЭДО
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLegalEntityEdo(requestParameters: UpdateLegalEntityEdoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public updateLegalEntityEdo(requestParameters: UpdateLegalEntityEdoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public updateLegalEntityEdo(requestParameters: UpdateLegalEntityEdoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public updateLegalEntityEdo(requestParameters: UpdateLegalEntityEdoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling updateLegalEntityEdo.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const updateEdoRequest = requestParameters.updateEdoRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/edo`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateEdoRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Подключить акты сверки ЭДО
     * Отправка заявки на подключение актов сверки ЭДО
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLegalEntityEdoRecact(requestParameters: UpdateLegalEntityEdoRecactRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public updateLegalEntityEdoRecact(requestParameters: UpdateLegalEntityEdoRecactRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public updateLegalEntityEdoRecact(requestParameters: UpdateLegalEntityEdoRecactRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public updateLegalEntityEdoRecact(requestParameters: UpdateLegalEntityEdoRecactRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling updateLegalEntityEdoRecact.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/edo/recact`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Изменить email
     * Изменяет информацию об электронной почте организации
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLegalEntityEmail(requestParameters: UpdateLegalEntityEmailRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<void>;
    public updateLegalEntityEmail(requestParameters: UpdateLegalEntityEmailRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<void>>;
    public updateLegalEntityEmail(requestParameters: UpdateLegalEntityEmailRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<void>>;
    public updateLegalEntityEmail(requestParameters: UpdateLegalEntityEmailRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling updateLegalEntityEmail.');
        }
        const passportAccessToken = requestParameters.passportAccessToken;
        const xOrganizationID = requestParameters.xOrganizationID;
        const timestamp = requestParameters.timestamp;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;
        const legalEntityEmailRequest = requestParameters.legalEntityEmailRequest;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }

        let localVarHeaders = this.defaultHeaders;
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'B2B',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/b2b/legalEntity/email/update`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: legalEntityEmailRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
